import { type PropsWithChildren } from "react";

export const Header = ({ children }: Readonly<PropsWithChildren>) => (
  <header
    data-testid="circle-ai-shell-inset-header"
    className="isolate shrink-0"
  >
    {children}
  </header>
);

Header.displayName = "CircleAIAppShell.Layout.Inset.Header";
